import { get } from 'api';
import { cleanObject } from 'utils/object';

import {
  ACCOUNT_REPRESENTATIVES_LOADED,
  LOAD_ACCOUNT_REPRESENTATIVES,
  RESET_ACCOUNT_REPRESENTATIVES,
  SYNC_FAILED,
} from './actionTypes';
import type { IGetAccountRepresentativesParams } from './types';
import { productTypeUrlPrefix } from 'utils';
import { APP_PRODUCT_TYPE } from 'appConstants';

export const initialActionsState = {
  loadAccountRepresentatives: () => {},
  resetAccountRepresentatives: () => {},
};

export const getActions = (dispatch: { (value: { type: any; payload?: any }): void }) => ({
  loadAccountRepresentatives: async (
    params: IGetAccountRepresentativesParams = {},
    productType = '',
  ) => {
    dispatch({
      type: LOAD_ACCOUNT_REPRESENTATIVES,
    });

    const { data, error } = await get(
      productTypeUrlPrefix(productType, '/representatives', [APP_PRODUCT_TYPE.CROP]),
      {
        params: cleanObject(params),
      },
    );

    if (!error) {
      dispatch({
        type: ACCOUNT_REPRESENTATIVES_LOADED,
        payload: { data: Array.isArray(data) ? data : [], productType },
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: { error, productType },
      });
    }
  },

  resetAccountRepresentatives: () =>
    dispatch({
      type: RESET_ACCOUNT_REPRESENTATIVES,
    }),
});
